export enum RuleDetailPageAction {
  EDIT_SETTINGS = 'editSettings',
  DELETE = 'delete',
  PAUSE = 'pause',
}
